import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { PinnedLinksFavoritesComponent } from './pinned-links-favorites.component'
import { AvatarCardModule } from '../../libs/avatar-card/avatar-card.module'
import { RouterModule } from '@angular/router'
import { SvgModule } from '../../shared/svg/svg.module'
import { FloTypeGuardModule } from 'src/app/shared/pipes/flo-type-guard-pipe.module'
import { CustomLinkModule } from 'src/app/libs/custom-link/custom-link.directive.module'
import { AnalyticsModule } from 'src/app/shared/analytics/analytics.module'

@NgModule({
  imports: [
    CommonModule,
    AvatarCardModule,
    AnalyticsModule,
    RouterModule,
    SvgModule,
    FloTypeGuardModule,
    CustomLinkModule
  ],
  exports: [PinnedLinksFavoritesComponent],
  declarations: [PinnedLinksFavoritesComponent]
})
export class PinnedLinksFavoritesModule {}
